import { privateApi } from "@/core/api";

export async function verifyRequest() {
  const response = await privateApi.get("/auth/verify");
  return response.data;
}
